import { createPageSlice } from "./createPageSlice";

// Server-paginated slice for the "All Clients / Accounts" Master Data grid.
const clientPageSlice = createPageSlice("clientPage", {
    defaultSortBy: "name",
    defaultSortDirection: "ASC",
});

export const clientPageActions = clientPageSlice.actions;
export default clientPageSlice;
